import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const colorMap = {
  Bajo: "bg-success text-success-foreground",
  Medio: "bg-warning text-warning-foreground",
  Alto: "bg-destructive text-destructive-foreground",
};

export default function RiskBadge({ risk, className }) {
  const safe = risk || "Medio";
  return (
    <Badge
      data-testid={`risk-badge-${safe.toLowerCase()}`}
      className={cn("rounded-full font-medium border-0", colorMap[safe], className)}
    >
      {safe}
    </Badge>
  );
}
